import { GoalRepository } from '../../domain/repository';
import { GoalStore, OrganizationStore, UiState } from '../../domain/store';

export class GoalUsecase {
  private goalRepository: GoalRepository;
  private goalStore: GoalStore;
  private organizationStore: OrganizationStore;
  private uiState: UiState;

  constructor({
    goalRepository,
    goalStore,
    organizationStore,
    uiState,
  }: {
    goalRepository: GoalRepository;
    goalStore: GoalStore;
    organizationStore: OrganizationStore;
    uiState: UiState;
  }) {
    this.goalRepository = goalRepository;
    this.goalStore = goalStore;
    this.organizationStore = organizationStore;
    this.uiState = uiState;
  }

  public async getGoals() {
    const { goalRepository, goalStore, organizationStore, uiState } = this;
    uiState.clearError();
    goalStore.clearGoalList();
    goalStore.setLoading(true);
    const goals = await goalRepository.getGoalsOfOrganization(organizationStore.selectedOrganizationId);
    if (goals.length === 0) {
      uiState.enableOnboardingScreen();

      // if (currentUserStore.currentUser.admin) {
      //   uiState.setError({
      //     title: 'Experience Portfolio の準備を始めましょう',
      //     message: 'Lift Report の集計対象のゴールを設定すると、Experience Portfolio も同時に作成されます。',
      //     actionLabel: 'Lift Report 集計対象ゴールを設定する',
      //     action: () =>
      //       window.open(`${config.active_admin}/goals?user_id_equals=${organizationStore.selectedOrganizationId}`),
      //     showEmptyStateImage: true,
      //   });
      // } else {
      //   uiState.setError({
      //     title: 'Experience Portfolio の準備を始めましょう',
      //     message:
      //       'Lift Report の集計対象のゴールを設定すると、Experience Portfolio も同時に作成されます。<br />管理者権限をもったユーザーにゴールの設定を依頼してください。',
      //     actionLabel: '',
      //     showEmptyStateImage: true,
      //   });
      // }
    }
    await goalStore.setGoalList(goals);
    goalStore.setSelectedGoalId();
    goalStore.setLoading(false);
  }

  public setInitialSelectedGoalId() {
    const { goalRepository, goalStore } = this;
    const goalIdFromUrl = goalRepository.getSelectedGoalIdFromUrl();
    goalStore.setSelectedGoalId(goalIdFromUrl);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/application/usecase/GoalUsecase.ts